import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { paths } from '@perpay-web/fintech/props/appPaths';

import styles from './CardApplicationError.scss';

const CardApplicationError = ({
    onClickDone,
    dashboardURL = paths.dashboard.path,
}) => (
    <LegacyFocusLayout
        className={styles.container}
        footer={
            <CardCta
                Component={CustomLink}
                onClick={onClickDone}
                href={dashboardURL}
                className={styles['footer-button']}
            >
                Done
            </CardCta>
        }
    >
        <ResponsiveHeader>Oops something went wrong...</ResponsiveHeader>
        <ResponsiveCopy className={styles.copy}>
            We were unable to complete review of your application for the Perpay
            Credit Card due to a processing error.
        </ResponsiveCopy>
        <ResponsiveCopy className={styles.copy}>
            Please wait a few minutes and try again.
        </ResponsiveCopy>
    </LegacyFocusLayout>
);

export default CardApplicationError;
